export default __webpack_public_path__ + "static/media/element_spec_82.29297846.webp";